exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Theme Colors */\n.nested-history-table .expanded-row-value {\n  max-width: 250px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: inline-block;\n  vertical-align: middle;\n}\n.nested-history-table thead.ant-table-thead th.ant-table-cell {\n  color: #9ba0aa;\n}\n", ""]);

// exports
